import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { reportBreadcrumbsHistory } from './functions';

const FeedbackReportBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="report-breadcrumbs"
      history={reportBreadcrumbsHistory(t, location)}
    />
  );
};

export default FeedbackReportBreadcrumbs;
